import { CtaButton } from "ui/components/1-atoms/Action/CtaButton";

export const CtaButtonFeature: React.FC<Content.CtaButton> = ({content, settings}) => {
    return (<CtaButton title={content.properties.ctaText} link={content.properties.link} position={settings.properties.position}/>);
}

